import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  colors,
  fontSize as size,
  fontFamily as family,
} from '../../Design_System/DesignSystem';

interface TextProps {
  color?: string;
  fontSize?: string;
  fontFamily?: string;
  bold: boolean;
  justify: boolean;
  children: ReactNode;
  className?: string;
}

export const Text = ({
  color = colors.tan,
  fontFamily = family.tinos,
  fontSize = size.small,
  bold,
  justify,
  children,
  className,
}: TextProps) => {
  return (
    <TextStyle
      className={className}
      color={color}
      fontSize={fontSize}
      fontFamily={fontFamily}
      bold={bold ? true : false}
      justify={justify ? true : false}
    >
      {children}
    </TextStyle>
  );
};

const TextStyle = styled.p<{
  fontSize?: string;
  fontFamily?: string;
  bold: boolean;
  justify: boolean;
}>`
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  font-family: ${(props) => props.fontFamily};
  font-weight: ${(props) => (props.bold ? '700' : '400')};
  text-align: ${(props) => (props.justify ? 'justify' : 'none')};
  margin: 0;
  line-height: 1.5;
`;
